<template>
  <el-tag size="medium" type="warning">
    <i class="fas fa-exclamation-triangle"></i>
    {{ vbDocBccInfoId ? "BCC-DT" : "BCC" }}
  </el-tag>
</template>

<script>
  export default {
    name: "doc-bcc-tag",
    props: ["vbDocBccInfoId"],

    data() {
      return {};
    },

    watch: {
      processType() {
        this.initComponent();
      }
    },

    created() {
      this.initComponent();
    },

    methods: {
      initComponent() {
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-in/doc-bcc-tag.vue